import React, { FunctionComponent } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import Logo from './components/Logo';
import { useMediaQuery, useTheme } from '@material-ui/core';

const DarkBackgroundContainer = styled(Box)`
  ${({ theme }) => `
    background: ${theme.palette.text.primary};
    padding: ${theme.spacing(5, 3)}
  `}
`;
const SectionFooter: FunctionComponent = () => {
  const { formatMessage } = useIntl();
  const { breakpoints } = useTheme();

  const breakpoint = useMediaQuery(breakpoints.up('sm'));

  return (
    <DarkBackgroundContainer>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography
            align={!breakpoint ? 'center' : 'left'}
            color="textSecondary"
            variant="body2"
          >
            Copyright 2020 <Logo />
          </Typography>
          <Box my={1} />
          <Typography
            align={!breakpoint ? 'center' : 'left'}
            color="textSecondary"
            variant="body2"
          >
            contact@club-finder.app
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            display="flex"
            justifyContent={!breakpoint ? 'center' : 'flex-end'}
          >
            <Typography color="textSecondary" variant="body2">
              <Link component={RouterLink} to="/imprint" color="textSecondary">
                {formatMessage({ id: `footer.imprint` })}
              </Link>
            </Typography>
            <Box mx={1} />
            <Typography color="textSecondary" variant="body2">
              <Link component={RouterLink} to="/data" color="textSecondary">
                {formatMessage({ id: `footer.privacy` })}
              </Link>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </DarkBackgroundContainer>
  );
};

export default SectionFooter;
